export const GetGeneralPermissionForAction = (screen, allowType) => {
    const authToken = localStorage.getItem("auth-token");
    if (authToken === null) return false;
    var auth = JSON.parse(authToken);
    const permission = auth.generalPermissions.find(permission => permission.screen === screen);
    return permission != null && permission[allowType] ? true : false;
}
